import { defineModule } from '@berky/module-contract'

/**
 * Das Manifest ist die einzige Verbindung zwischen Modul und Shell.
 * Die Shell findet diese Datei selbst — sie muss nirgends eingetragen werden.
 */
export default defineModule({
  id: 'plantafel',
  title: 'Plantafel',
  description: 'Produktionskapazitäten planen und Fertigstellungstermine überblicken.',
  icon: 'CalendarDays',
  order: 100,
  apiBasePath: '/api/plantafel',

  // Kein scopes-Feld: die Anmeldung an der API macht die Plattform. Sie kennt
  // den Bereich der Umgebung, in der sie gerade läuft — useApiClient() hängt
  // das passende Token von selbst an.

  // Nur Nutzer mit einer Plantafel-Rolle sehen das Modul in der Navigation,
  // auf der Startseite oder über einen direkten Routenaufruf.
  roles: ['plantafel.nutzer', 'plantafel.admin'],

  routes: () => import('./src/routes'),

  // Optional: eine Kennzahl für die Kachel auf der Startseite.
  // homeWidget: () => import('./src/home-widget'),
})
